<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card style="height:550px">
      <md-card-content>
        <md-layout md-flex="10"></md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex="45">
            <md-layout md-flex="70">
              <h2>New Assignment</h2>
            </md-layout>
            <!-- <md-layout md-flex="30">
              <md-button
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                disabled
                @click="addClient"
              >Add New client</md-button>
            </md-layout>-->
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="50">
            <label for="objectItem">Client Name</label>

            <model-list-select
              :list="clientList"
              v-model="objectItem"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Client Name"
            ></model-list-select>

            <span class="error" v-if="!clientListData.clientName">{{clientNameError}}</span>
          </md-layout>

          <!-- <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>Contact Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="clientContact"
                name="clientContact"
                v-model="clientListData.phoneKYC"
                disabled
              ></b-form-input>
            </md-layout>
          </md-layout>-->
          <md-layout md-flex="15"></md-layout>
          <md-layout md-flex="15" v-if="checkIsContract==true">
            <md-button
              class="md-raised md-primary heght-1px md-button-color pull-right"
              @click="hireModel()"
            >Contract</md-button>
          </md-layout>
        </md-layout>

        <!-- <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Client Address</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="	clientAddress"
                name="	clientAddress"
                v-model="clientListData.corporateAddress"
                disabled
              ></b-form-textarea>
            </md-layout>
          </md-layout>
        </md-layout>-->
        <div class="box" v-if="viewAllQuotation.length>0">
          <hr class="hr-border" />
          <div class="box-header">
            <h3 class="box-title">Quotation details</h3>
          </div>

          <div class="box-body">
            <table id="quotationDetail" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Quotation List</th>

                  <th>Location Details</th>

                  <th>Sales Amount</th>
                  <th>Approval Status</th>
                  <th>Quotation Status</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in viewAllQuotation" :key="index">
                  <td>
                    Quotation {{index+1}}
                    <br />
                    <b>Generated On :</b>
                    {{ item.loginTime | moment}}
                    <br />
                    <b>Valid Till :</b>
                    {{ item.validityDate | moment}}
                  </td>

                  <td>
                    <b>Pickup Location :</b>
                    {{item.fromLocation}}
                    <br />
                    <b>Factory Location :</b>
                    {{item.StuffingLocation}}
                    <br />
                    <b>Handover Location :</b>
                    {{item.toLocation}}
                  </td>

                  <td>{{item.quoteSalesCost}}</td>
                  <td style="color:green">{{item.status}}</td>
                  <td style="color:red" v-if="item.expireStatus=='1'">Expired</td>
                  <td v-else>Valid till {{item.validityDate | moment}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      :disabled="permissionStatus?true:checkIsContract"
                      @click="viewQuotation(item.quotationId,item.salesBookingId,item.clientId)"
                    >
                      <md-icon>visibility</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr class="hr-s" />
        <!-- <md-list>
          <md-list-item
            id="letCheck"
            @click="scrl"
            class="md-button-color-toggle"
            v-bind:class="viewAllQuotation.length==0?'md-active':''"
          >
            <span>New Quotation</span>

            <md-list-expand>
              <md-list>
                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="type">Transport Type</label>
                    <model-list-select
                      :list="transportTypeList"
                      v-model="salesList.type"
                      :disabled="permissionStatus?true:checkIsContract"
                      option-value="transportTypeVal"
                      option-text="transportTypeText"
                      placeholder="Select Transport Type"
                    ></model-list-select>
                    <span class="error" v-if="!salesList.type">{{typeError}}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="AutoPickupLocation">Pickup Location</label>

                    <model-list-select
                      @input="getLocationList($event,'All','getLocationData')"
                      @searchchange="getLocationList($event,'All','getLocationData')"
                      :list="getLocationData"
                      v-model="AutoPickupLocation"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Pickup Location"
                    ></model-list-select>

                    <span class="error" v-if="!salesList.fromLocation">{{fromLocationError}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="AutoStuffingLocation">Factory Location</label>

                    <model-list-select
                      :list="factoryDetail"
                      :isDisabled="salesList.type=='Empty_Moment'?true:factoryDetail.length==0?true:false"
                      v-model="salesList.stuffingLocationId"
                      option-value="location"
                      option-text="factoryTitle"
                      :placeholder="factoryDetail.length>0?'Select Factory Location':'No Factory'"
                    ></model-list-select>

                    <span
                      class="error"
                      v-if="!salesList.stuffingLocationId"
                    >{{StuffingLocationError}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <label for="AutoHandoverLocation">Handover Location</label>

                    <model-list-select
                      @input="getLocationList($event,'All','getLocationHandover')"
                      @searchchange="getLocationList($event,'All','getLocationHandover')"
                      :list="getLocationHandover"
                      v-model="AutoHandoverLocation"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Select Handover Location"
                    ></model-list-select>

                    <span class="error" v-if="!salesList.toLocation">{{toLocationError}}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="AutoContainerType">Container Type</label>

                    <model-list-select
                      :isDisabled="salesList.multipleContainerType.length>0?true:false"
                      :list="containerTypeList"
                      v-model="AutoContainerType"
                      option-value="containerTypeId"
                      option-text="containerType"
                      placeholder="Select Container Type"
                    ></model-list-select>
                  </md-layout>

                  <md-layout
                    md-flex="70"
                    v-if="salesList.multipleContainerType.length>0"
                    style="margin-top:30px"
                  >
                    <md-chip
                      md-deletable
                      v-for="(type,index) in salesList.multipleContainerType"
                      :key="index"
                      @delete="deleteContainer(type)"
                    >{{type}}</md-chip>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>No. Of Container</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="noOfContainer"
                        name="noOfContainer"
                        v-model="salesList.noOfContainer"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="90">
                    <md-layout md-flex="100">
                      <label>Commodity Details</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="transportDetail"
                        name="transportDetail"
                        v-model="salesList.transportDetail"
                        :disabled="permissionStatus?true:checkIsContract"
                      ></b-form-textarea>
                    </md-layout>
                    <span class="error" v-if="!salesList.transportDetail">{{transportDetailError}}</span>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>Weight</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="otherDetail"
                        name="otherDetail"
                        v-model="salesList.otherDetail"
                        :disabled="permissionStatus?true:checkIsContract"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="40">
                    <md-layout md-flex="100">
                      <label>Remarks</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="comment"
                        name="comment"
                        v-model="salesList.comment"
                        :disabled="permissionStatus?true:checkIsContract"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <hr class="hr-border">
                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="35"></md-layout>

                  <md-layout md-flex="30">
                    <md-button
                      class="md-raised md-primary md-button-color"
                      :disabled="permissionStatus?true:checkIsContract"
                      @click="showQuotation"
                      id="addButtonLoader"
                    >Check Costing / Send Quotation</md-button>
                    <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                  </md-layout>
                  <md-layout md-flex="25"></md-layout>
                </md-layout>
              </md-list>
            </md-list-expand>
          </md-list-item>
        </md-list>-->
      </md-card-content>
    </md-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert1.content1" :md-ok-text="alert1.ok1" ref="addPop1"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/sales/salesBooking");

      this.getClientList();
      this.fetchContainer();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export"
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import"
        },
        {
          transportTypeVal: "Empty_Moment",
          transportTypeText: "Empty Moment"
        }
      ],

      searchText: "",
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      clientListData: {
        clientId: "",
        clientName: "",
        corporateAddress: "",
        phoneKYC: ""
      },
      contacts: ["Marcos Moura"],
      alert: {
        content: "a",
        ok: "ok"
      },
      alert1: {
        content1: "a",
        ok1: "ok"
      },
      options1: [
        { code: "01", name: "aa", desc: "desc01" },
        { code: "02", name: "ab", desc: "desc02" },
        { code: "03", name: "bc", desc: "desc03" },
        { code: "04", name: "cd", desc: "desc04" },
        { code: "05", name: "de", desc: "desc05" },
        { code: "06", name: "ef", desc: "desc06" }
      ],
      objectItem: {},
      AutoPickupLocation: {},
      AutoHandoverLocation: {},
      AutoStuffingLocation: {},
      AutoContainerType: {},

      salesList: {
        salesBookingId: "",
        clientId: "",
        clientName: "",
        billingPartyName: "",
        clientContact: "",
        clientAddress: "",
        jobType: "",
        salesBookingDate: "",
        fromLocation: "",
        toLocation: "",
        StuffingLocation: "",
        containerType: "",
        doValidity: "",
        containerQuantity: "",
        type: "",
        status: "",
        transportDetail: "",
        otherDetail: "",
        comment: "",
        toLocationId: "",
        fromLocationId: "",
        stuffingLocationId: "",
        multipleContainerType: [],
        multipleContainerTypeId: [],
        noOfContainer: ""
      },
      factoryDetail: [],
      tempfactoryDetail: [],
      isLoading: false,
      NoofVehicleError: "",
      containerTypeDetail: ["dsfds"],
      viewAllQuotation: [],
      assignListArray: [],
      JobType: [],
      showJobType: [],
      clientNameError: "",
      billingPartyNameError: "",
      toLocationError: "",
      JobTypeError: "",
      typeError: "",

      fromLocationError: "",
      transportDetailError: "",
      getLocationHandover: [],
      StuffingLocationError: "",

      billingPartyName: "",
      validate: true,
      checkIsContract: false,

      getCLientData: [
        {
          clientId: "2",
          clientName: "Saif",
          companyType: "privateLimited",
          corporateAddress: "gdfg"
        }
      ],
      getLocationData: [
        {
          pickupId: "2",
          pickupLocation: "Saif",
          pickupIsActive: "privateLimited"
        }
      ]
    };
  },
  watch: {
    objectItem: {
      handler: function(newVal, oldVal) {
        this.clientCallback(newVal);
      },
      deep: true
    },
    AutoPickupLocation: {
      handler: function(newVal, oldVal) {
        this.masterCallback2(newVal);
      },
      deep: true
    },

    AutoHandoverLocation: {
      handler: function(newVal, oldVal) {
        this.masterCallback1(newVal);
      },
      deep: true
    },

    AutoContainerType: {
      handler: function(newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true
    }
  },

  mounted() {
    // this.JqueryFun();
    // this.getData();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    containerTypeList() {
      return this.containerTypeDetail;
    },
    masterListPick() {
      return this.getLocationPickUp;
    },
    // masterListHand() {
    //   return this.getLocationHandover;
    // },
    transportTypeList() {
      return this.transportTypeName;
    }
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    scrl() {
      window.scroll(0, 800);
    },
    // doLoading() {
    //   this.isLoading = true;
    // },
    // doLoadingClose() {
    //   this.isLoading = true;

    //   setTimeout(() => {
    //     this.isLoading = false;
    //   }, 500);
    // },

    hireModel() {
      let contractlist = this.$store.getters.storeContractList;

      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      let contractFilter = [];
      if (contractlist != undefined) {
        let contractFilter = contractlist.filter(y => {
          let validDate = new Date(y.toValidity);

          return (
            y.clientId == this.clientListData.clientId &&
            validDate > currentDate
          );
        });

        if (contractFilter.length > 0) {
          this.$sessionsStorage.set(
            "setContractId",
            contractFilter[0].contractId
          );
          this.$sessionsStorage.set("clientId", this.clientListData.clientId);
          this.$router.push({
            path: "/listView/hireModel"
          });
        } else {
          this.alert1.content1 =
            "Please add a new contract . Your Contract validity is out of date.";
          this.$refs["addPop1"].open();
        }
      }
    },
    deleteContainer(item) {
      let i = this.salesList.multipleContainerType.indexOf(item);

      this.salesList.multipleContainerType.splice(i, 1);
      this.salesList.multipleContainerTypeId.splice(i, 1);
    },
    validateSalesBookingForm() {
      let validate_new = true;

      if (this.clientListData.clientName == "") {
        $("#clientName").focus();
        this.clientNameError = "Enter your client name";
        validate_new = false;
      }

      if (this.clientListData.clientName == "") {
        $("#clientName").focus();
        this.clientNameError = "Enter your client name";
        validate_new = false;
      }

      if (this.salesList.toLocation == "") {
        $("#toLocation").focus();
        this.toLocationError = "Enter your Location";
        validate_new = false;
      }

      // if (this.salesList.StuffingLocation == "") {
      //   $("#toLocation").focus();
      //   this.StuffingLocationError = "Enter your Location";
      //   validate_new = false;
      // }

      if (this.salesList.transportDetail == "") {
        $("#transportDetail").focus();
        this.transportDetailError = "Enter your transport detail";
        validate_new = false;
      }

      if (this.salesList.fromLocation == "") {
        $("#fromLocation").focus();
        this.fromLocationError = "Enter your  Location";
        validate_new = false;
      }

      if (this.salesList.type == "") {
        $("#type").focus();
        this.typeError = "Select Type";
        validate_new = false;
      }
      if (
        this.salesList.StuffingLocation == "" &&
        this.salesList.type != "Empty_Moment"
      ) {
        $("#StuffingLocation").focus();
        this.StuffingLocationError = "Enter your Stuffing Location";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    clientFilter(list, query) {
      return this.getCLientData.filter(x => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },

    masterFilter(list, query) {
      return this.getLocationData.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },

    masterCallback1(item) {
      let filterMasterList = this.getLocationHandover.filter(y => {
        return y.pickupId == item.pickupId;
      });
      this.salesList.toLocationId = item.pickupId;
      this.salesList.toLocation = item.pickupLocation;
    },

    masterCallback2(item) {
      console.log(item, "fsdfsdfsd");

      let filterMasterList = this.getLocationData.filter(y => {
        return y.pickupId == item.pickupId;
      });
      this.salesList.fromLocation = item.pickupLocation;
      this.salesList.fromLocationId = item.pickupId;
    },
    masterCallbackContainer(item) {
      if (this.salesList.multipleContainerType.length > 0) {
        let i = this.salesList.multipleContainerType.indexOf(
          item.containerType
        );

        if (i < 0) {
          this.salesList.multipleContainerType.push(item.containerType);
          this.salesList.multipleContainerTypeId.push(item.containerTypeId);
        }
      } else {
        this.salesList.multipleContainerType.push(item.containerType);
        this.salesList.multipleContainerTypeId.push(item.containerTypeId);
      }
      this.salesList.containerType = "";
    },
    containerTypeFilter(list, query) {
      return this.containerTypeDetail.filter(x => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },

    viewMoreClientDetail(obj) {
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewClientDetail.php`,
        data: JSON.stringify(obj),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.quotationList.length > 0) {
              this.viewAllQuotation = data.quotationList;
            } else {
              this.viewAllQuotation = [];
            }
            console.log(data);

            console.log(data, "fdsfsdf");
            if (data.factoryDetail.length > 0) {
              this.factoryDetail = data.factoryDetail;
              this.tempfactoryDetail = data.factoryDetail;
            } else {
              this.factoryDetail = [];
              this.tempfactoryDetail = [];
            }

            this.JqueryFun();

            if (data.salesBookingList.length > 0) {
              this.getLocationData = data.locationDetail;
              this.getLocationHandover = data.locationDetail;

              Object.keys(data.salesBookingList[0]).map(x => {
                this.salesList[x] = data.salesBookingList[0][x] || "";
                if (
                  x == "jobType" ||
                  x == "multipleContainerType" ||
                  x == "multipleContainerTypeId"
                ) {
                  this.salesList[x] =
                    data.salesBookingList[0][x].split(",") || [];
                }
              });

              this.AutoPickupLocation = this.getLocationData.filter(x => {
                return x.pickupId == this.salesList.fromLocationId;
              })[0];

              this.AutoHandoverLocation = this.getLocationData.filter(x => {
                return x.pickupId == this.salesList.toLocationId;
              })[0];
            } else {
              Object.assign(this.salesList, {
                clientId: "",
                clientName: "",
                billingPartyName: "",
                clientContact: "",
                clientAddress: "",
                jobType: "",
                salesBookingDate: "",
                fromLocation: "",
                toLocation: "",
                type: "",
                status: "",
                transportDetail: "",
                otherDetail: "",
                comment: "",
                salesBookingId: "",
                containerQuantity: "",
                containerType: "",
                noOfContainer: "",
                stuffingLocationId: "",
                StuffingLocation: "",
                multipleContainerType: [],
                multipleContainerTypeId: [],
                doValidity: ""
              });
              this.AutoPickupLocation = {};
              this.AutoHandoverLocation = {};
            }

            this.showJobType.map((x, index) => {
              let i = this.salesList.jobType.indexOf(x.value);
              i >= 0
                ? (this.JobType[index] = true)
                : (this.JobType[index] = false);
            });
            if (data.contractDetail[0].hireContract == "hireContract") {
              this.checkIsContract = true;
            } else {
              this.checkIsContract = false;
            }
          }
        })
        .catch(error => {});
    },

    clientCallback(item) {
      this.isLoading = true;
      this.clientListData.clientName = item.clientName;
      let viewclientlist = this.$store.getters.storeClientList;
      // let viewsaleslist = this.$store.getters.storeSalesList;
      // let viewsquotationlist = this.$store.getters.storeQuotationsList;

      let filterClientList = viewclientlist.filter(x => {
        return x.clientId == item.clientId && x.isKYC == "Yes";
      });

      if (filterClientList.length > 0) {
        Object.keys(filterClientList[0]).map(x => {
          this.clientListData[x] = filterClientList[0][x] || "";
        });
        let obj = { clientId: item.clientId };

        this.viewMoreClientDetail(obj);

        // let filtersalesList = viewsaleslist.filter(y => {
        //   return y.clientId == item.clientId && y.isQuotation == 0;
        // });

        // this.factoryDetail = this.tempfactoryDetail.filter(x => {
        //   return x.clientId == item.clientId;
        // });
        // let quotationtList = viewsquotationlist.filter(x => {
        //   return x.clientId == item.clientId;
        // });
      } else {
        this.alert1.content1 = "Note: First complete the Kyc ";
        Object.keys(this.salesList).map(x => {
          if (
            x == "jobType" ||
            x == "multipleContainerType" ||
            x == "multipleContainerTypeId"
          ) {
            this.salesList[x] = [];
          } else {
            this.salesList[x] = "";
          }
        });

        this.viewAllQuotation = [];

        this.$refs["addPop1"].open();
        this.clientListData.clientName = "";
        this.clientListData.corporateAddress = "";
        this.clientListData.phoneKYC = "";
        this.AutoPickupLocation = {};
        this.AutoHandoverLocation = {};
      }
      this.isLoading = false;
    },

    fetchContainer() {
      let vehicle_drive = {
        container: "container"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/fetchContainerType_Sales.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.containerTypeDetail = data.containerDetail;
          }
        })
        .catch(error => {});
    },

    JqueryFun() {
      return $(function() {
        return $("#quotationDetail").DataTable();
      });
    },

    JobTypeVal(index, value) {
      value == "All" && index == 4
        ? this.JobType[index] == true
          ? (this.JobType = Array(this.showJobType.length).fill(false))
          : (this.JobType = Array(this.showJobType.length).fill(true))
        : this.JobTypeVal[index] == true;
    },
    addClient() {
      this.$sessionsStorage.set("editClientType", "Client");
      if (globalPermissionStatus("addClient") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("addClient")
        );
        this.$router.push({
          path: "/client/addClient",
          name: "Add Clients"
        });
      } else {
        alert("You dont have permission to add Client");
      }
    },
    previousSalesView() {
      this.$router.push({
        path: "/listView/viewSalesBooking"
      });
    },

    onClose() {
      this.$router.push({
        path: "/vehicle/quotation"
      });
    },
    showQuotation() {
      if (
        this.factoryDetail.length > 0 &&
        this.salesList.stuffingLocationId != ""
      ) {
        this.salesList.StuffingLocation = this.factoryDetail.filter(x => {
          return x.location == this.salesList.stuffingLocationId;
        })[0]["factoryTitle"];
      }

      this.validateSalesBookingForm();

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let newJObTypeVal = ["Trucking"];

        let new_data = {
          clientName: this.clientListData.clientName,
          billingPartyName: this.salesList.billingPartyName,
          clientContact: this.clientListData.phoneKYC,
          clientAddress: this.clientListData.corporateAddress,
          jobType: newJObTypeVal,
          salesBookingDate: this.salesList.salesBookingDate,
          fromLocation: this.salesList.fromLocation,
          toLocation: this.salesList.toLocation,
          StuffingLocation: this.salesList.StuffingLocation,
          doValidity: this.salesList.doValidity,
          type: this.salesList.type,
          status: this.salesList.status,
          transportDetail: this.salesList.transportDetail,
          otherDetail: this.salesList.otherDetail,
          comment: this.salesList.comment,
          clientId: this.clientListData.clientId,
          salesBookingId: this.salesList.salesBookingId,
          containerQuantity: this.salesList.containerQuantity,
          containerType: this.salesList.containerType,
          fromLocationId: this.salesList.fromLocationId,
          toLocationId: this.salesList.toLocationId,
          stuffingLocationId: this.salesList.stuffingLocationId,
          typeOfForm: "Sales",
          multipleContainerType: this.salesList.multipleContainerType,
          multipleContainerTypeId: this.salesList.multipleContainerTypeId,
          noOfContainer: this.salesList.noOfContainer
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/salesBooking.php`,
          data: JSON.stringify(new_data),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              data.salesBookingId != "" &&
              
              status == 200
            ) {
              if (data.msg == "Succesfully Inserted") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated  Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");

              this.$sessionsStorage.set("clientId", data.clientId);
              this.$sessionsStorage.set("salesBookingId", data.salesBookingId);
              this.$sessionsStorage.set("storeQuotationId", "false");

              this.$sessionsStorage.set("storeAssignId", "false");

              // this.$refs["addPop"].open();

              var currentDate = new Date(this.salesList.salesBookingDate);
              currentDate.setDate(currentDate.getDate() + 2);

              var doValidity = new Date(this.salesList.doValidity);
              if (doValidity < currentDate) {
                this.alert1.content1 =
                  "Note :- Your DO Validity will expire in 2 days ..!";
                this.$refs["addPop1"].open();
              }
              this.onClose();
            }
          })

          .catch(error => {});
      }
    },

    assignmentOrder() {
      this.$router.push({
        name: "Assignment Order",
        path: "/vehicle/assignmentOrder",
        name: "Assignment Order"
      });
    },
    getData() {
      this.showJobType = [
        {
          value: "FF",
          show: "FF",
          flex: "10"
        },
        {
          value: "CC",
          show: "CC",
          flex: "10"
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15"
        },

        {
          value: "Yard",
          show: "Yard",
          flex: "10"
        },
        {
          value: "All",
          show: "All",
          flex: "10"
        }
      ];
      this.JobType = Array(this.showJobType.length).fill(false);
    },
    selectFromParentComponent1(searchText) {
      if (searchText == "") {
        this.clientCallback(this.objectItem);
      }
    },
    viewQuotation(quotationId, salesId, clientId) {
      if (globalPermissionStatus("QuotationAssignment") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("QuotationAssignment")
        );

        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$sessionsStorage.set("salesBookingId", salesId);
        this.$sessionsStorage.set("clientId", clientId);
        // let assignArray = this.assignListArray.filter(
        //   x => x.quotatinId == quotationId
        // );
        // if (assignArray.length > 0) {
        //   this.$sessionsStorage.set("storeAssignId", assignArray[0].assignId);
        // } else {
        //   this.$sessionsStorage.set("storeAssignId", "false");
        // }

        this.$router.push({
          path: "/vehicle/quotation"
        });
      } else {
        alert("You dont have permission for Sales booking form");
      }
    },
    selectOption() {
      this.objectItem = this.options[0];
    },
    getClientList() {
      this.isLoading = true;
      let new_data = {
        allView: "ClientList",
        clientId: this.$sessionsStorage.get("clientId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/getClientListSaleBooking.php`,
        data: JSON.stringify(new_data),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.getCLientData = data.allclient.filter(x => {
              return x.clientType != "Lead";
            });
            this.getLocationData = data.locationMaster;
            this.getLocationHandover = data.locationMaster;
            // this.assignListArray = data.assignOrderList;
            // this.$store.dispatch("setSalesList", data.salesList);
            this.$store.dispatch("setclientList", this.getCLientData);
            // this.$store.dispatch("setquotationList", data.quotationList);
            this.$store.dispatch("setLocationList", data.locationMaster);

            if (
              this.$sessionsStorage.get("clientId") != "" &&
              this.$sessionsStorage.get("clientId") != undefined
            ) {
              // let obj = {
              //   clientId: this.$sessionsStorage.get("clientId")
              // };

              this.objectItem = this.getCLientData.filter(x => {
                return x.clientId == this.$sessionsStorage.get("clientId");
              })[0];
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 5px;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.mx-input-icon__calendar {
  margin-top: 0px !important;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// salesBookingForm.vue?1ac03557